import {h, Fragment} from "preact"
export default function Skeleton({ className }) {
    return (
        <div className={`ns-skeleton-wrapper ${className}`}>
            {/* Navigation skeleton to prevent layout shift */}
            <div className="ns-skeleton-nav"></div>
            <div className="ns-skeleton-grid">
                {/* Generate 9 skeleton cards */}
                {Array.from({ length: 9 }, (_, i) => (
                    <div key={i} className="ns-skeleton-card">
                        <div className="ns-skeleton-image skeleton skeleton--image"></div>
                        <div className="ns-skeleton-content">
                            <div className="ns-skeleton-title skeleton skeleton--text"></div>
                            <div className="ns-skeleton-price skeleton skeleton--text"></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}